import ListSuppliers from "../../../../components/@groups/suppliers/ListSuppliers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SupplierGroupsPage() {

    return (
        <ListSuppliers 
            routeType={routeTypes.admin}
        />
    )
}       